<template>
	<div class="tpl add-friend-wrap">
		<mt-header title="添加好友" fixed>
		  <router-link :to="{name:'friend-list'}" slot="left">
		    <mt-button icon="back"></mt-button>
		  </router-link>
		  <mt-button class="add-friend-btn" @click.native="addFriend()" icon="more" slot="right"></mt-button>
		</mt-header>
		<mt-search v-model="searchValue" cancel-text="取消" placeholder="搜索" autofocus></mt-search>
		<div class="search-result-list">
			<p class="list-title" v-if="fList.length>0">搜索结果</p>
			<mt-cell v-for="(item,index) in fList" :key="item.uid" v-if="fList.length>0">
				<div class="list-item">
					<div class="item-img" @click="goToFriendPage(item.uid)">
						<img :src="item.avatar" />
						<span class="is-online">
			  			<img v-if="item.is_vip==0" src="../../assets/img/chats/ic_tips_offline@2x.png" alt="" />
			  			<img v-if="item.is_vip==1" src="../../assets/img/chats/ic_tips_online@2x.png" alt="" />
			  		</span>
					</div>
					<div class="item-text">
						<p class="item-name">{{item.nickname}}
							<span class="item-sex">
			  				<img v-if="item.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
			  				<img v-if="item.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
			  			</span>
							<span class="is-vip" v-if="item.is_vip==1">
			  				<img src="../../assets/img/common/ic_user_vip@2x.png"/>
			  			</span>
						</p>
						<p class="item-other">
							ID:{{item.uid}}
						</p>
						<p class="item-sig">
							{{item.sig||"此用户很懒，尚未设置个性签名~"}}
						</p>
					</div>
					<div class="item-btn">
						<button @click="sendAddApply(item.uid)">添加好友</button>
					</div>
				</div>
			</mt-cell>
			<div class="no-content" v-if="fList.length<1">
				<img src="../../assets/img/default/bg_img_noresults@2x.png"/>
				<p>没有搜索结果~</p>
			</div>
		</div>
	</div>
</template>

<script>
//	import Mint from "mint-ui"
	export default {
		name: "add-friend",
		data() {
			return {
				uid: "",
				searchValue: "",
				nowPage:"1",
				fList: []
			}
		},
		created() {
			this.uid = this.$store.state.UserId;
			this.$store.commit("changeTabChoosed", "chats");
			this.$store.commit("changeTabBarShow", false);

			this.getList();
		},
		watch: {
			searchValue() {
				this.getList();
//				console.log(this.searchValue)
			}
		},
		methods: {
			//获取搜索结果
			getList() {
				this.$axios({
					url:"Chat/SearchFriendList",
					method:"post",
					data:{
						search_criteria:this.searchValue,
						page:this.nowPage
					}
				}).then(res => {
//					console.log(res);
					if(res.data.code == 200) {
						this.fList = res.data.data;
					}else{
						this.fList = [];
					}
//					console.log(this.fList.length)

				}).catch(err => {
					console.log(err);
					this.$indicator.close();
					this.$toast({
						message:"请求失败，请重试",
						position:"bottom",
						duration:3000
					})
				})
			},
			//发出添加好友申请
			sendAddApply(oId) {
//				console.log("添加好友" + oId);
				this.$axios({
						url: "Chat/addfriend",
						method: "post",
						params: {
							uid: this.uid,
							other_uid: oId
						},
					})
					.then(res => {
						console.log(res);
						if(res.data.code){
							this.$toast({
							  message: res.data.msg,
							  position: 'bottom',
							  duration: 3000
							});
						}
					})
					.catch(err => {
						console.log(err)
					})
			},
			goToFriendPage(id){
				console.log(id);
				if(id==this.uid){
					this.$toast({
						message: "这是你自己哦~",
						position: "bottom",
						duration: 3000
					});
				}else{
					this.$router.push({
						name:"my-page-other",
						query:{
							oid:id
						}
					})
				}
				
			},
		}
	}
</script>

<style scoped>
	.add-friend-wrap {
		padding-top: 5.3rem;
	}
	
	.mint-search {
		position: fixed;
		width: 100%;
		height: auto;
		top: 2.5rem;
		left: 0;
		z-index: 10;
	}
	
	>>>.mint-searchbar {
		background-color: #fff;
		border-bottom: 1px solid #f3f3f3;
	}
	
	>>>.mint-searchbar-inner {
		background: rgba(40, 40, 40, .12);
		border-radius: 1rem;
		padding: 0 0.8rem;
	}
	
	>>>.mint-searchbar-inner .mintui-search {
		color: #7644FA;
		font-size: 1rem;
	}
	
	>>>.mint-searchbar-inner input {
		background: none;
		padding: 0 0.5rem;
	}
	
	>>>.mint-searchbar-cancel {
		color: #7644FA;
		font-size: 0.8rem;
	}
	
	>>>.mint-cell-value {
		width: 100%;
	}
	
	.search-result-list .list-title {
		padding: 0.5rem;
		font-size: 0.8rem;
		color: #9e9e9e;
		border-bottom: 1px solid #f3f3f3;
	}
	
	>>>.mint-cell-value {
		width: 100%;
	}
	
	.list-item {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		border-bottom: 1px solid #f3f3f3;
		padding: 0.5rem 0;
	}
	
	.list-item .item-img {
		width: 3rem;
		height: 3rem;
		overflow: hidden;
		position: relative;
		margin: 0.5rem;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.list-item .item-img>img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}
	
	.list-item .is-online {
		position: absolute;
		top: -0.1rem;
		right: -0.2rem;
		width: 1rem;
		height: 1rem;
		overflow: hidden;
	}
	
	.list-item .is-online img {
		width: 100%;
		display: block;
	}
	
	.list-item .item-text {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		padding: 0 0.5rem;
	}
	
	.list-item .item-name {
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
	}
	
	.list-item .item-name img {
		width: 1.5rem;
	}
	
	.list-item .item-other {
		font-size: 0.65rem;
		line-height: 1rem;
	}
	
	.list-item .item-sig {
		font-size: 0.65rem;
		line-height: 1rem;
		color: #4a4a4a;
	}
	
	.list-item .item-btn {
		display: flex;
		align-items: center;
	}
	
	.list-item .item-btn button {
		color: #7644FA;
		border: 1px solid #7644FA;
		background: none;
		border-radius: 2rem;
		padding: 0.3rem 0.8rem;
		outline: 0;
	}
	
	.list-item .item-btn button:active {
		color: #fff;
		background: #7644FA;
	}
</style>


// WEBPACK FOOTER //
// src/components/Chats/AddFriend.vue